const React = require("react");
const PropTypes = require("prop-types");
const { HTMLSafeInjector } = require("commonsComponents/htmlSafeInjector");
const { OKButton } = require("commonsComponents/OKButton");
const { formatText } = require("core/i18n").i18n;

const LoggedOnPublicUserFundBox = (props) => {
    const { fund, user, isAlternativeFund } = props;
    const prospectNotification = user.get("prospectNotification");
    const layoutColor = user.get("layoutColor");
    const redirectHire = user.get("redirectHire");
    const hireURL = isAlternativeFund
        ? `/myprofile/broker/buyAlternativeInvestmentFunds/${fund.isin}`
        : `/myprofile/broker/buyInvestmentFunds/${fund.customInstitutionSecurityId}`;
    return (
        <div
            className="prospect-user-fund-box"
            style={{ backgroundColor: layoutColor }}
        >
            <section>
                <HTMLSafeInjector
                    customClass={"user-fund-box__no-user-box"}
                    message={prospectNotification}
                />
            </section>
            <section className="purse__actions">
                {((fund.custom && fund.custom.customCategoryId3) ||
                    (isAlternativeFund && fund.marketable)) && (
                    <OKButton
                        modifier="primary"
                        onClick={() => redirectHire(hireURL)}
                    >
                        {formatText("fundsCard-buyButton")}
                    </OKButton>
                )}
            </section>
        </div>
    );
};

LoggedOnPublicUserFundBox.propTypes = {
    fund: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    isAlternativeFund: PropTypes.bool,
};

module.exports = LoggedOnPublicUserFundBox;
